var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Autocomplete, TextField, } from '@mui/material';
import { descriptors as descriptorsOptions, hasCommaDescriptors as hasCommaDescriptorsOptions, } from '../../../utils/cuppingComment';
var CuppingDescriptorsAutocomplete = function (_a) {
    var value = _a.value, onChange = _a.onChange;
    var t = useTranslation().t;
    var isRequiredSplit = React.useCallback(function (option) {
        if (!option)
            return false;
        return (option.includes(',') && !hasCommaDescriptorsOptions.includes(option));
    }, [hasCommaDescriptorsOptions]);
    var splitOption = React.useCallback(function (createOptionValue) {
        var replacedInputValue = createOptionValue;
        hasCommaDescriptorsOptions.forEach(function (option) {
            replacedInputValue = createOptionValue.replace(new RegExp(option, 'i'), option.replace(',', ''));
        });
        return replacedInputValue
            .split(',')
            .map(function (value) {
            return (descriptorsOptions.find(function (option) {
                return new RegExp("^".concat(option.replace(',', ''), "$"), 'i').test(value.trim());
            }) || value.trim());
        })
            .filter(function (value, index, array) { return array.indexOf(value) === index; });
    }, [hasCommaDescriptorsOptions]);
    var normalizeOptionValue = React.useCallback(function (_a) {
        var reason = _a.reason, _b = _a.values, values = _b === void 0 ? [] : _b, _c = _a.optionValue, optionValue = _c === void 0 ? '' : _c;
        if (reason !== 'createOption' || !isRequiredSplit(optionValue))
            return values;
        var newValues = [];
        values.forEach(function (value) {
            if (value !== optionValue)
                return newValues.push(value);
            splitOption(optionValue).forEach(function (option) { return values.includes(option) || newValues.push(option); });
        });
        return newValues;
    }, [isRequiredSplit, splitOption]);
    return (React.createElement(Autocomplete, { multiple: true, freeSolo: true, disablePortal: true, autoHighlight: true, value: value, onChange: function (_event, value, reason, details) {
            onChange(normalizeOptionValue({
                reason: reason,
                values: value,
                optionValue: (details === null || details === void 0 ? void 0 : details.option) || '',
            }));
        }, options: descriptorsOptions, getOptionLabel: function (descriptor) { return descriptor; }, isOptionEqualToValue: function (option, value) { return option === value; }, renderInput: function (params) { return (React.createElement(TextField, __assign({}, params, { label: t('params.cuppingComment.cuppingDescriptors') }))); } }));
};
export default CuppingDescriptorsAutocomplete;
